import React from 'react'
import { IconChartArea, IconDownload } from '@tabler/icons-react'
import Typography from '../../../atoms/Typography'

const MIOMBO_REPORT_URL = '/Miombo_Woodlands_of_Southern_Africa_Report_RAMO_2026.pdf'

const MiomboReportMessage: React.FC = () => {
  return (
    <div className="flex w-full flex-col gap-[10px] p-3">
      {/* Message text */}
      <Typography variant="sm-medium" className="whitespace-pre-wrap text-light-green-50">
        {`Hello! I'm Copa, your agentic team lead for Miombo regional insights.\n\nMiombo woodlands play a critical role in climate mitigation, biodiversity conservation, and rural livelihoods across southern Africa. They support millions of people through fuelwood, charcoal, agriculture, and ecosystem services, while storing significant biomass carbon stocks at continental scale.\n\nI've prepared a detailed Miombo Woodland Report for this region. You can download it below or ask me specific questions about starting a Nature-based Solution project in this area.`}
      </Typography>

      {/* Report card */}
      <div className="flex w-full flex-col gap-4 rounded-[8px] border border-gray-500 bg-gray-900 px-6 py-4">
        {/* Report info */}
        <div className="flex w-full items-start gap-3">
          <div className="flex h-6 w-6 shrink-0 items-center justify-center">
            <IconChartArea className="h-6 w-6 text-light-green-500" stroke={1.5} />
          </div>
          <div className="flex flex-1 flex-col gap-0">
            <Typography variant="sm-bold" className="text-gray-200">
              Miombo Woodlands of Southern Africa Report
            </Typography>
            <Typography variant="xs" className="text-gray-400">
              Comprehensive report on land use change, carbon stocks and climate finance opportunities in the Miombo
              region
            </Typography>
          </div>
        </div>

        {/* Download button */}
        <a
          href={MIOMBO_REPORT_URL}
          download="Miombo_Woodlands_of_Southern_Africa_Report_RAMO_2026.pdf"
          className="flex h-7 w-full items-center justify-center gap-2 rounded-[100px] bg-light-green-500 px-4 py-1 transition-all duration-200 hover:brightness-110"
        >
          <IconDownload className="h-5 w-5 text-gray-50" stroke={1.5} />
          <Typography variant="sm-medium" className="text-gray-50">
            Download
          </Typography>
        </a>
      </div>
    </div>
  )
}

export default MiomboReportMessage
